/**
 * FailedToken コンポーネント
 * 
 * TOKEN検証エラー時に表示する画面です。
 * https://<domain>/failedToken からアクセスされます。
 * 
 * Reduxのstateから言語情報を取得し、選択されている言語を反映します。
 * 
 * @component
 * @example
 * <FailedToken />
 */

import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import logo from "ASSETS/Images/img_header_logo.webp";
import "./WaitingScreen.less";
import { getMessage, changeLanguage } from "CONFIG/i18n";
import { getLanguage } from "@/Routes/selectors";

/**
 * TOKEN検証エラー時に表示する画面
 */
export class FailedToken extends Component {
  /**
   * コンストラクタ
   * @param {object} props 
   */
  constructor(props){
    super(props);
  }

  /**
   * コンポーネントマウント時に呼ばれるライフサイクルメソッド
   * 選択されている言語を反映します
   */
  componentDidMount = () => {
    changeLanguage();
  }

  /**
   * レンダリング
   * @returns {JSX.Element}
   */
  render() {
    return (
      <div>
        <section className="bgColor">
          <Row className="waitingHeader">
            <Col lg="8" md="8" xs="9" className="headerLogoContainer pl-0">
              <img className="logoHeader" src={logo} />
            </Col>
          </Row>
          <Container>
            <Row>
              <Col
                md="12"
                lg="12"
                className={"text-center sessionEnded"}
              >
                <h4 className="topMargin text-center">
                  {getMessage("TOKEN_VALIDATION_FAILED")}
                </h4>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    );
  }
}

/**
 * Reduxのstateから言語情報を取得
 * @param {object} state
 * @returns {object}
 */
const mapStateToProps = state => {
  return {
    language: getLanguage(state),
  };
};

export default connect(
  mapStateToProps,
)(FailedToken);

// ...existing code...